export default __webpack_public_path__ + "static/media/8.3ad12581.png";